import React from 'react';
import classNames from 'classnames';
import './styles.styl';
import { kebabCase } from 'lodash';
import icons from '../../assets/comet/comet.svg';

const FlipCardSide = ({ data, back, seen }) => {
  const cardClasses = () => {
    return classNames(
      `flip-card__${back ? 'back' : 'front'}`,
      'flip-card__side',
      `flip-card__side--flipped`
    );
  };

  const buttonClasses = classNames(
    'flip-cards__footer__button',
    'comet-button'
  );

  const footerText = () => {
    if (data.footerText) return data.footerText;

    return back ? 'Got it' : 'Learn More';
  };

  return (
    <div className={cardClasses()}>
      <div className="comet-card__copy flip-card__side__copy">
        {/* TODO: do we want above image text? */}
        <div className="comet-thumbnail">
          <div className="comet-thumbnail__inner">
            <img alt="" height="280" src={data.image} width="402" />
          </div>
        </div>
        <section className="comet-card__content">
          <h2>{data.header}</h2>
          {data.text}
        </section>
        <footer className="modal-cards__footer flip-cards__footer">
          <p
            id={`${kebabCase(data.title)}-button-text`}
            className={`modal-cards__footer-text flip-cards__footer__text--${
              back ? 'back' : 'front'
            }`}
          >
            {footerText()}
          </p>
          <button
            className={buttonClasses}
            aria-labelledby={`${kebabCase(data.title)}-button-text`}
          >
            <svg
              id="icon"
              className={`flip-cards__icon--${back ? 'back' : 'front'}`}
              xmlns="http://www.w3.org/2000/svg"
              height="30px"
              width="40px"
            >
              {!back && seen ? (
                <use xlinkHref={`${icons}#check`} />
              ) : (
                <path d="M37.5 11.3L26.9.7c-.3-.3-.7-.5-1.1-.5s-.8.2-1.1.5L14.1 11.3c-.5.6-.4 1.5.2 2 .6.5 1.5.4 2-.2l8.4-8.2c.2 7.8-1.1 13.2-3.9 16.1-1.8 1.9-4.1 2.8-7.2 2.8-3.2 0-5.5-.9-7.2-2.8-2.7-3-3.7-8.7-2.8-16.9.1-.8-.5-1.6-1.3-1.6-.9 0-1.6.6-1.7 1.4-1 9.2.2 15.4 3.6 19.2 2.2 2.5 5.4 3.7 9.4 3.7 3.9 0 7.1-1.2 9.4-3.7 3.3-3.5 4.8-9.2 4.7-17.4l7.5 7.4c.5.6 1.4.7 2 .2.3-.2.5-.6.5-1 .1-.3 0-.7-.2-1z" />
              )}
            </svg>
            <span className="comet-screenreader-only">{data.text}</span>
          </button>
        </footer>
      </div>
    </div>
  );
};

export default FlipCardSide;



// WEBPACK FOOTER //
// ../core/src/components/FlipCards/FlipCardSide.js